export default function invariant(condition: unknown, error: Error): asserts condition {
  if (condition) return

  throw error
}
